<template>
    <div class="animated fadeIn dashboard dashboard-socios">
      <b-row>
        <b-col>
          <app-rentabilidad-socios
            ref="rentabilidadSocios"
            @consultarSueldosRetiros="consultarSueldosRetiros"
            @consultarRetirosSocios="consultarRetirosSocios">
          </app-rentabilidad-socios>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <app-retiros-socios
            v-if="showRetirosSocios"
            ref="retiros"
            :items="retirosSocios"
            :anio="anio"
            :totalRegistros="totalRegistrosRetiros"
            :paginaActual="paginaActualRetiros">
          </app-retiros-socios>

          <app-sueldos-retiros
            v-if="showSueldosRetiros"
            ref="sueldos"
            :items="sueldosRetiros"
            :anio="anio"
            :totalRegistros="totalRegistrosSueldos"
            :paginaActual="paginaActualSueldos">
          </app-sueldos-retiros>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col>
          <app-reinversion
            ref="reinversion">
          </app-reinversion>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import RentabilidadSocios from './socios/RentabilidadSocios';
import RetirosSocios from './socios/RetirosSocios';
import SueldosRetiros from './socios/SueldosRetiros';
import Reinversion from './socios/Reinversion';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  components: {
    appRentabilidadSocios: RentabilidadSocios,
    appRetirosSocios: RetirosSocios,
    appSueldosRetiros: SueldosRetiros,
    appReinversion: Reinversion,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

  data() {
    return {
      anio: '',
      retirosSocios: [],
      totalRegistrosRetiros: 0,
      paginaActualRetiros: 1,
      sueldosRetiros: [],
      totalRegistrosSueldos: 0,
      paginaActualSueldos: 1,
    }
  },
  computed: {
    showRetirosSocios() {
      if (this.retirosSocios) {
        return this.retirosSocios.length != 0;
      }
      return false;
    },
    showSueldosRetiros() {
      if (this.sueldosRetiros) {
        return this.sueldosRetiros.length != 0;
      }
      return false;
    }
  },
  methods: {
    getIndicadores() {
      this.$store.dispatch('indicadoresSocios/getInformeRentabilidad')
        .then(() => {
          this.$refs.rentabilidadSocios.getIndicador();
          this.$refs.reinversion.getIndicador();
        });
    },
    consultarRetirosSocios(anio) {
      this.showSpinner();
      this.$store.dispatch('indicadoresSocios/getRetirosSocios', anio)
        .then(() => {
          this.sueldosRetiros = [];
          this.retirosSocios = this.$store.getters['indicadoresSocios/retirosSocios'];
          this.totalRegistrosRetiros = this.retirosSocios.length;
          this.paginaActualRetiros = 1;
          this.anio = anio;
        })
        .finally(() => this.hideSpinner());
    },
    consultarSueldosRetiros(anio) {
      this.showSpinner();
      this.$store.dispatch('indicadoresSocios/getSueldosRetiros', anio)
        .then(() => {
          this.retirosSocios = [];
          this.sueldosRetiros = this.$store.getters['indicadoresSocios/sueldosRetiros'];
          this.totalRegistrosSueldos = this.sueldosRetiros.length;
          this.paginaActualSueldos = 1;
          this.anio = anio;
        })
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
</style>


